import React from 'react';
import { FaExternalLinkAlt } from 'react-icons/fa';
import '../assets/components/_testimonials.scss';

const Testimonials = () => {
  return (
    <div className="page-container">
      <div className="content-wrapper">
        <div className="section-header">
          <h1>Recognition</h1>
          <p>Press coverage and feedback from colleagues and mentors</p>
        </div>

        <div className="clean-card">
          <div className="card-header" style={{ marginBottom: '0.5rem' }}>
            <span className="badge" style={{ background: '#ebf8ff', color: '#2b6cb0', padding: '0.25rem 0.75rem', borderRadius: '999px', fontSize: '0.8rem', fontWeight: 600 }}>
              In the News
            </span>
          </div>
          <h3>Old Dominion University Partners with U.S. Cyber Command</h3>
          <p>
            ODU's nationally recognized School of Cybersecurity began work with U.S. Cyber Command to
            advance the country's use of artificial intelligence in cyber defense. I was selected as one
            of three doctoral students on the research team, alongside Dr. Takabi and
            Dr. GhasemiGol.
          </p>
          <blockquote style={{ borderLeft: '4px solid #3182ce', margin: '1.25rem 0', padding: '0.4rem 0 0.4rem 1.1rem', color: '#4a5568', fontStyle: 'italic' }}>
            "They will make us complete researchers — not only researchers, but practical implementers.
            You have the research and you can implement it so it could be used by any company or institution."
            <div style={{ fontStyle: 'normal', fontSize: '0.85rem', marginTop: '0.5rem', color: '#718096' }}>
              — quoted in the ODU announcement
            </div>
          </blockquote>
          <a
            href="https://www.odu.edu/article/old-dominion-university-researchers-partner-us-cyber-command-to-solve-national"
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-primary"
          >
            Read the article <FaExternalLinkAlt />
          </a>
        </div>

        <div className="clean-card" style={{ marginTop: '1.5rem' }}>
          <h3>Testimonials</h3>
          <p>Recommendations from colleagues, mentors, and collaborators.</p>
          <div className="coming-soon">
            <span>Coming soon</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Testimonials;
